import PermanentBookingContainer from "./PermanentBookingContainer";
import { Route, Switch } from 'react-router-dom'
import ViewPermanentBooking from "./ViewPermanentBooking";
// import FlightSearchPage from "../FlightSearchPage";
import EditPermanentBooking from "./EditPermanentBooking";
const PermanentBookingRoot = () => <Switch>
    <Route
        exact
        path='/permanent-booking'
        component={PermanentBookingContainer}
    />
    <Route
        exact
        path='/permanent-booking/edit'
        component={EditPermanentBooking}
    />
    <Route
        exact
        path="/permanent-booking/view/:awbNo?/:ubrNo?"
        component={ViewPermanentBooking}
    />
</Switch>

export default PermanentBookingRoot